/* globals alert, console, module, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    _ = require('lodash'),
    helpers = require('../utilities/handlebars').helpers;

// jQuery(window).keydown(function (event) {
//     console.log('hola, mis!');
//     if (event.keyCode === 13) {
//         event.preventDefault();
//         return false;
//     }
// });

jQuery.ajaxSetup({cache: true}); // @acavan! do we need cache buster?
